import {Component, Vue} from 'vue-property-decorator';
import {ValidationObserver} from 'vee-validate';
import {AxiosError} from 'axios';
import {debug} from '@/utils/helpers';

@Component
export default class SetValidationErrors extends Vue {
  /**
   * Set validation errors from Axios Error Object.
   *
   * @param e
   */
  setValidationErrors(e: AxiosError) {
    const errors = (e.response?.data?.data?.errors || []).reduce(
      (prev: any, current: any) => {
        const {path, message} = current;
        if (!prev[path]) {
          prev[path] = [];
        }
        prev[path].push(message);
        return prev;
      },
      {},
    );
    debug(errors);
    (<InstanceType<typeof ValidationObserver>>this.$refs.form).setErrors(
      errors,
    );
    debug(this.$refs.form);
    if (Object.keys(errors).length > 0) {
      this.$vuetify.goTo(0);
    }
  }
}
